/* Optional delivery coordinates. Google Maps loads only after a saved pin exists. */
(function () {
  'use strict';
  let loading;
  function load(key) {
    if (window.google?.maps?.importLibrary) return Promise.resolve();
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const callback = 'dwGoogleMapsReady';
      window[callback] = () => { delete window[callback]; resolve(); };
      script.src = 'https://maps.googleapis.com/maps/api/js?' + new URLSearchParams({key, loading:'async', v:'quarterly', callback});
      script.async = true;
      script.onerror = () => { loading = null; delete window[callback]; script.remove(); reject(Error('Map unavailable')); };
      document.head.append(script);
    });
    return loading;
  }
  window.DWDeliveryLocation = {
    async mount(root, coordinates, key, onChange) {
      const button = root.querySelector('[data-dw-current-location]');
      const box = root.querySelector('[data-dw-map-box]');
      const clear = root.querySelector('[data-dw-clear-location]');
      button.classList.toggle('dw-location-saved', Boolean(coordinates));
      button.textContent = coordinates ? '✓ Location saved' : 'Use My Current Location (optional)';
      clear.hidden = !coordinates; box.hidden = !coordinates;
      if (!coordinates) { box.replaceChildren(); return; }
      const update = point => {
        const latitude = typeof point.lat === 'function' ? point.lat() : point.lat;
        const longitude = typeof point.lng === 'function' ? point.lng() : point.lng;
        if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return;
        onChange({latitude,longitude});
      };
      update({lat:coordinates.latitude,lng:coordinates.longitude});
      const canvas = document.createElement('div'); canvas.className = 'dw-delivery-map'; canvas.setAttribute('aria-label','Google Map. Drag the pin or map to adjust your delivery location.');
      box.replaceChildren(canvas);
      if (!key) { canvas.textContent = 'Map unavailable. Your optional coordinates are saved; you can still enter your address below.'; return; }
      try {
        await load(key);
        const [{Map}, {AdvancedMarkerElement}] = await Promise.all([google.maps.importLibrary('maps'),google.maps.importLibrary('marker')]);
        if (!canvas.isConnected) return;
        const map = new Map(canvas,{center:{lat:coordinates.latitude,lng:coordinates.longitude},zoom:17,mapId:'DEMO_MAP_ID',gestureHandling:'cooperative',mapTypeControl:false,streetViewControl:false,fullscreenControl:false});
        const marker = new AdvancedMarkerElement({map,position:map.getCenter(),gmpDraggable:true,title:'Delivery pin — drag to adjust'});
        marker.addListener('dragend', () => { update(marker.position); map.panTo(marker.position); });
        map.addListener('dragend', () => { marker.position=map.getCenter(); update(map.getCenter()); });
        map.addListener('click', event => { if(event.latLng){marker.position=event.latLng;update(event.latLng);map.panTo(event.latLng);} });
      } catch { if(canvas.isConnected) canvas.textContent='Google Map could not load. Your optional coordinates are saved; address entry still works.'; }
    }
  };
  // Size the row to whole items plus half the next item. Never reset scrollLeft.
  const observer = new ResizeObserver(entries => entries.forEach(({target,contentRect}) => {
    const count=target.children.length, gap=10, width=contentRect.width;
    if (!width || count<2) return;
    const whole=Math.min(count-1,Math.max(2,Math.floor(width/105)));
    const basis=(width-gap*whole)/(whole+.5);
    target.style.setProperty('--dw-category-width',basis+'px');
  }));
  document.querySelectorAll('.dw-category-ribbon ul,.dw-hero-grid .categories-slider--list').forEach(row=>observer.observe(row));
})();
